import { render } from "./ThreeScreenshot.vue?vue&type=template&id=5ca80a10&scoped=true&ts=true"
import script from "./ThreeScreenshot.vue?vue&type=script&lang=ts"
export * from "./ThreeScreenshot.vue?vue&type=script&lang=ts"

import "./ThreeScreenshot.vue?vue&type=style&index=0&id=5ca80a10&scoped=true&lang=scss"

import exportComponent from "/Users/gerald/Projects/designium/RandselSimulation/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ca80a10"]])

export default __exports__